import { useQuery } from '@tanstack/react-query'
import { historyService } from '../api/historyService'
import { WAR_ROOM_QUERY_KEYS } from '../api/queryClient'

export function useExecutionHistory(params: { page?: number; per_page?: number; outcome?: string } = {}) {
  return useQuery({
    queryKey: [...WAR_ROOM_QUERY_KEYS.history(''), params] as const,
    queryFn: () => historyService.list(params),
    staleTime: 5 * 60_000, // history rarely changes
    placeholderData: (prev) => prev,
  })
}

export function useExecutionRecord(sessionId: string) {
  return useQuery({
    queryKey: WAR_ROOM_QUERY_KEYS.executionRecord(sessionId),
    queryFn: () => historyService.getRecord(sessionId).then((r) => r.data),
    staleTime: 5 * 60_000,
    enabled: !!sessionId,
  })
}
